import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import ListHelpers from '../helpers/ListHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import Utilities from '../helpers/Utilities'
import OrderHelpers from '../helpers/OrderHelpers'
import FileHelpers from '../helpers/FileHelpers'
import StringHelpers from '../helpers/StringHelpers'

var db = fb.database()

const state = {
    tabs: [],
    elements: [],
    fields: [], 
    triggers: [], 
    selectedElement: {},
    deletingElement: {},
    selectedSection: null,
    selectedTab: null,
    // loadedTabs: [],
    uploadingCount: 0,
}

// getters
const getters = {

    tabs: state => {
        return state.tabs
    },
    // loadedTabs: state => {
    //     return state.loadedTabs
    // },
    selectedTab: state => {
        return state.selectedTab
    },
    elements: state => {
        return state.elements
    },
    uploadingCount: state => {
        return state.uploadingCount
    },
     

    transactionContacts: state => {
        return state.elements.filter(o => o.type == 'Contact' && o.contact).map(o => {
            return {
                key: o.contactKey,
                email: o.contact.email,
                mobile: o.contact.mobile,
                fax: o.contact.fax,
                firstName: o.contact.firstName,
                preferredName: o.contact.preferredName || null,
                lastName: o.contact.lastName,
                fullName: ContactHelpers.fullName(o.contact),
                role: o.role,
                image: o.contact.image,
            }
        })
    },

    selectedElement: state => {
        return state.selectedElement
    },
    selectedSection: state => {
        return state.selectedSection
    },
    deletingElement: state => {
        return state.deletingElement
    },
    fields: state => {
        return state.fields
    },
    triggers: state => {
        return state.triggers
    },
    fieldIdentifiers: state => {
        return state.fields.map(o => o.identifier)
    }
}

// actions
const actions = {

    //Element related actions...

    saveElement(context, obj) {
        Utilities.log('ElementsStore > saveElement', obj)
        obj.transactionKey = obj.transactionKey || context.getters.transaction.key
        obj.tenantKey = context.getters.tenantKey
        let newObj = ListHelpers.prepareSave(obj) 
        context.commit('saveElement', newObj)
        let ref = DataHelpers.getTransactionRef().child('elements')
        FirebaseHelpers.saveToFirebase(newObj, ref)
    },

    updateElementValue(context, obj) {
        let newObj = Object.assign({}, obj)
        context.commit('saveElement', newObj)
        let ref = DataHelpers.getTransactionRef().child('elements')
        FirebaseHelpers.saveToFirebase(newObj, ref)
    },

    deleteElement(context, obj) {
        Utilities.log('ElementsStore > deleteElement', obj)
        context.commit('deleteElement', obj)
        let ref = DataHelpers.getTransactionRef().child('elements')
        FirebaseHelpers.deleteFromFirebase(obj, ref)
    },    

    //Tab related actions...

    deleteTab(context, obj) {
        Utilities.log('ElementsStore > deleteTab', obj)
        context.commit('deleteTab', obj)
        let ref = DataHelpers.getTransactionRef().child('tabs')
        FirebaseHelpers.deleteFromFirebase(obj, ref)
    },    

    selectTab(context, obj) {
        //Utilities.log('ElementsStore > selectTab')
        context.commit('setSelectedTab', obj)
        context.commit('setSelectedTask', null)
        context.commit('allCommentsMode', false)
    }, 
    selectSection(context, obj) {
        //Utilities.log('ElementsStore > selectSection')
        context.commit('setSelectedSection', obj)
        context.commit('setSelectedTask', null)
        context.commit('allCommentsMode', false)
    }, 

    //Upload related...

    uploadFiles(context, {files, element}) {
        
        for(var n = 0; n < files.length; n++) {
            let file = files[n]

            if(file.size > 7500000) {
                AlertHelpers.showAlert('File size is too big:' + file.name)
                continue // skips this iteration only
            }
            console.log('Uploading ' + file.name)

            context.commit('uploadingCountIncrement')
            //Save new file element
            const originalName = file.name
            const name = (element && element.targetName ? element.targetName : originalName)
            const fileName = FileHelpers.cleanFilename(name)
            

            let fileElement = {
                key: DataHelpers.getKey(),
                originalName,
                name,
                fileName,
                tabKey: 'settings',
                transactionKey: DataHelpers.getTransactionKey(),
                type: 'File',
                title: fileName,
                loading: true,
                url: null
            }
            context.dispatch('saveElement', fileElement)

            let transactionKey = DataHelpers.getTransactionKey()
            FileHelpers.fileToFirebase(file, `transactions/${transactionKey}/${file.name}`, function(progress) {
                console.log('PROGRESS', progress)
                fileElement.progress = progress
                context.dispatch('saveElement', fileElement)
            }).then((url) => {
                fileElement.value = url
                fileElement.loading = null
                fileElement.progress = null
                context.dispatch('saveElement', fileElement)
                context.commit('uploadingCountDecrement')
            })

            if(!element)
                continue

            if(!element.linkedFileKeys)
                element.linkedFileKeys = []
                
            element.linkedFileKeys.push(fileElement.key)
            context.dispatch('saveElement', element)


        }

    },

    //v1

    loadTabs(context) {
        return new Promise(function(resolve, reject) {

            let ref = db.ref(`tenants/${context.getters.tenantKey}/transactions/${context.getters.transaction.key}/elements`)
            ref.orderByChild('type').equalTo('Tab').once('value', function(snap) {
                console.log('store > loadTabs (first load)')
                let tabs = FirebaseHelpers.snapshotToArray(snap).sort(OrderHelpers.sortAscending)
                context.commit('appendElements', tabs)
                resolve('loaded')
            })  
        })
    },

    // loadElements(context, tabKey) {
    //     return new Promise(function(resolve, reject) {
    //         let loadedTabs = context.getters.loadedTabs
    //         if(loadedTabs.indexOf(tabKey) > -1) {
    //             Utilities.log('loadElements > tab already loaded')
    //             resolve('cached')
    //             return
    //         }
            
    //         Utilities.log('loadElements > first load')
    //         loadedTabs.push(tabKey)
    //         context.commit('setLoadedTabs', loadedTabs)

    //         let ref = db.ref(`tenants/${context.getters.tenantKey}/transactions/${context.getters.transaction.key}/elements`)
    //         ref.orderByChild('tabKey').equalTo(tabKey).once('value', function(snap) {
    //             console.log('store > loadElements (first load)')
    //             let elements = FirebaseHelpers.snapshotToArray(snap)
    //             context.commit('appendElements', elements)
    //             resolve('loaded')
    //         })  
    //     })
    // },

    loadAllElements(context) {
        return new Promise(function(resolve, reject) {

            let ref = db.ref(`tenants/${context.getters.tenantKey}/transactions/${context.getters.transaction.key}/elements`)
            ref.once('value', function(snap) {
                console.log('store > loadAllElements (first load)')
                let elements = FirebaseHelpers.snapshotToArray(snap)
                context.commit('setElements', elements)
                resolve('loaded')
            })  
        })
    },

    fetchElementsByType(context, type) {
        return new Promise(function(resolve, reject) {
            let ref = db.ref(`tenants/${context.getters.tenantKey}/transactions/${context.getters.transaction.key}/elements`)
            ref.orderByChild('type').equalTo(type).once('value', function(snap) {
                console.log('store > fetchElementsByType')
                let elements = FirebaseHelpers.snapshotToArray(snap)
                resolve(elements)
            })   
        })            
        
    }

}

// mutations
const mutations = {
    deleteElement (state, element) {
        ListHelpers.delete(element, state.elements)          
    },  
    
    setSelectedSection (state, newVal) {
        state.selectedSection = newVal           
    }, 
    setElements (state, elements) {
        state.elements = elements           
    }, 
    appendElements (state, elements) {
        state.elements = [...elements, ...state.elements]           
    }, 
    setSelectedElement (state, newVal) {
        state.selectedElement = newVal           
    }, 
    setDeletingElement (state, newVal) {
        state.deletingElement = newVal  
        setTimeout( () => {
            state.deletingElement = null
        }, 4000)         
    }, 
    
    saveElement (state, element) {
        ListHelpers.save(element, state.elements)          
    },   

    //Tab related mutations...

    deleteTab (state, tab) {
        ListHelpers.delete(tab, state.tabs)          
    },  
    setTabs (state, newVal) {
        state.tabs = newVal           
    }, 
    // setLoadedTabs (state, newVal) {
    //     state.loadedTabs = newVal           
    // }, 
    setSelectedTab (state, newVal) {
        state.selectedTab = newVal   
    }, 

    uploadingCount (state, newVal) {
        state.uploadingCount = newVal           
    },     
    uploadingCountIncrement (state, newVal) {
        state.uploadingCount ++           
    },     
    uploadingCountDecrement (state, newVal) {
        if(state.uploadingCount > 0)
            state.uploadingCount --           
    },     
    //v1 related...

    // setFields (state, fields) {
    //     state.fields = fields           
    // },              
    // setTriggers (state, triggers) {
    //     state.triggers = triggers           
    // },              
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/ElementsStore.js